import { useQuery } from '@tanstack/react-query';
import { Api } from '@/core/api';
import { IncidentItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';

export const QUERY_KEY_LINK_PREVIEW_MEDIA = 'link-preview-media';

export const useLinkPreviewMediaData = ({
  link,
  enabled,
}: {
  enabled?: boolean;
  link: IncidentItem['Hyperlink'] | undefined;
}) => {
  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_LINK_PREVIEW_MEDIA, link],
    queryFn: () => Api.getLinkPreviewMedia({ link: link! }),
    enabled: typeof enabled !== 'undefined' ? enabled : !!link,
    retry: 0,
  });

  return { data, ...query };
};
